import React, { useState } from "react";
import Accordion from "./Accordian";

const all_questions = [
  {
    question: " How do I book my driving lessons?",
    answer:
      "You can easily book your driving lessons online through our website or by giving us a call. Simply select your preferred time and instructor, and we'll confirm your booking.",
  },
  {
    question: "What are your lesson prices?",
    answer:
      "Our lesson prices vary depending on the package and duration you choose. We offer competitive rates, and you can find detailed pricing information on our website or by contacting our office. ",
  },
  {
    question:
      "Do I need to have a provisional driving licence before starting lessons?",
    answer:
      "Yes, you will need a valid provisional driving licence to start your lessons. If you don’t have one yet, you can apply for it through the DVLA.",
  },
  {
    question: "How many lessons will I need to pass my driving test?",
    answer:
      "The number of lessons required varies from person to person. Some learners may need just a few lessons, while others might need more practice. Our instructors will assess your progress and guide you on how many lessons you may need. ",
  },
  {
    question: "Can I take a lesson in my own car?",
    answer:
      "Yes, if you have a car that you’re comfortable with and want to take lessons in, we can arrange for you to use your own vehicle. However, please ensure that your car is insured and roadworthy.",
  },
  {
    question: "What happens if I need to cancel or reschedule a lesson?",
    answer:
      "If you need to cancel or reschedule, please give us at least 24 hours' notice to avoid any cancellation fees. We’ll work with you to find a new time that fits your schedule.",
  },
  {
    question: "Do you offer intensive driving lessons?",
    answer:
      "Yes, we offer intensive driving lessons for learners who want to accelerate their training. These courses are tailored to your needs and can help you pass your driving test in a shorter time frame. ",
  },
  {
    question: "Are your driving instructors fully qualified? ",
    answer:
      "Absolutely! All of our driving instructors are fully qualified, licenced by the DVSA (Driver and Vehicle Standards Agency), and have extensive teaching experience. ",
  },
  {
    question: "What types of vehicles do you use for driving lessons?",
    answer:
      "We use modern, well-maintained vehicles equipped with the latest safety features to ensure a comfortable and safe driving experience during your lessons.",
  },
  {
    question: "Do you provide training for the driving theory test?",
    answer:
      "Yes, we provide study materials and support to help you prepare for the driving theory test. Our instructors can guide you through key topics and offer advice on how to pass the test with confidence.",
  },
];

const Faqs = () => {
  const [questions, setQuestions] = useState(all_questions);
  const [search_text, setSearchText] = useState("");

  const onSearchQuestion = (e) => {
    const { value } = e.target;
    setSearchText(value);
    if (value)
      setQuestions(
        all_questions.filter((item) =>
          item.question.toLowerCase().includes(value.toLowerCase().trim())
        )
      );
    else setQuestions(questions);
  };

  const resetSearch = () => {
    setSearchText("");
    setQuestions(all_questions);
  };

  return (
    <section className="faq-page-section">
      <div className="auto-container">
        <div className="upper-box">
          <span className="big-text">q&amp;a</span>
          <div className="sec-title">
            <h2>
              Find answers in our <br />
              list of frequently asked questions
            </h2>
          </div>
          <div className="form-inner">
            <div className="form-group">
              <input
                type="search"
                name="search-field"
                placeholder="Search question..."
                onChange={onSearchQuestion}
                value={search_text}
                required=""
              />
              <button type="submit">
                {search_text.length > 0 ? (
                  <i className="bi bi-x-lg" onClick={resetSearch} />
                ) : (
                  <i className="bi bi-search" />
                )}
              </button>
            </div>
          </div>
        </div>

        <div>
          <Accordion questions={questions} />
        </div>
      </div>
    </section>
  );
};

export default Faqs;
